package com.flowyride.core.domain.model

/** What the rider does at a point of the route. Engine-specific kinds map to the closest one, or [OTHER]. */
enum class ManeuverType {
    DEPART,
    ARRIVE,

    /** An intermediate stop of the ride. */
    WAYPOINT,
    STRAIGHT,
    KEEP_LEFT,
    KEEP_RIGHT,
    BEAR_LEFT,
    BEAR_RIGHT,
    TURN_LEFT,
    TURN_RIGHT,
    SHARP_LEFT,
    SHARP_RIGHT,
    U_TURN,

    /** Any roundabout: see [Maneuver.roundaboutExit] and [Maneuver.turnAngle]. */
    ROUNDABOUT,
    EXIT_LEFT,
    EXIT_RIGHT,
    MERGE,
    FERRY,
    OTHER,
    ;

    /** Worth a banner: not every "continue" of the engine is. */
    val isAction: Boolean get() = this != STRAIGHT && this != OTHER && this != DEPART
}

/**
 * A turn-by-turn instruction.
 *
 * @param trackIndex Index in [Route.track] where the maneuver happens.
 * @param turnAngle Degrees, negative to the left; 0 = straight on. For roundabouts: the exit's direction.
 */
data class Maneuver(
    val type: ManeuverType,
    val trackIndex: Int,
    val roadName: String? = null,
    val roadNumber: String? = null,
    val roundaboutExit: Int? = null,
    val turnAngle: Double? = null,
)
